import { render, staticRenderFns } from "./userSettingsView.vue?vue&type=template&id=9c2fb36a"
import script from "./userSettingsView.vue?vue&type=script&lang=js"
export * from "./userSettingsView.vue?vue&type=script&lang=js"
import style0 from "./userSettingsView.vue?vue&type=style&index=0&id=9c2fb36a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports